export default __webpack_public_path__ + "static/media/no_cat.2e77442d.jpeg";